export enum messageStatuses {
  message = 0,
  auto_message = 10,
  system_message = 20
}